{ bool, func, instanceOf, oneOfType, string } = PropTypes
EtdEditor = require 'components/etd/etd_editor'
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

VotingAdminComment = ({
  adminComment,
  readOnly,
  renderMode,
  onApply
}) ->
  i18n = useI18n 'es:recommendations.table'
  onSaveContent = useCoffeeCallback [onApply], ({ content }) ->
    onApply? content

  <div className="admin-comment">
    <span className='admin-comment-caption'>{i18n 'summary'}</span>
    <EtdEditor
      cellId="adminComment"
      content={adminComment}
      editable
      noAutoSave={renderMode is 'printout'}
      noInsertOption
      noReferencesInsert
      onSaveContent={onSaveContent}
      readOnly={readOnly ? false}
      renderMode={renderMode}
    />
  </div>

VotingAdminComment.propTypes =
  adminComment: oneOfType [
    instanceOf(Immutable.Map)
    string
  ]
  renderMode: string.isRequired
  onApply: func
  readOnly: bool

module.exports = VotingAdminComment
